import Icon from '../components/Icon.vue'

Icon.register({
  'ruble-sign': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M239.4 320h-92.8v32h161.4c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-161.4v52c0 6.6-5.4 12-12 12h-58.6c-6.6 0-12-5.4-12-12v-52h-52c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h52v-32h-52c-6.6 0-12-5.4-12-12v-45.4c0-6.6 5.4-12 12-12h52v-206.6c0-6.6 5.4-12 12-12h163.4c85.1 0 144.6 57.6 144.6 143.1 0 85.5-59.5 144.9-144.6 144.9zM146.6 100.7v149.9h77.4c48 0 76.2-29.7 76.2-75.6 0-45.2-28.2-74.3-74.9-74.3h-78.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ruble-sign.js
// module id = 1849
// module chunks = 0